import React, { AnchorHTMLAttributes } from 'react'

type BasicLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>

// forwardRef to support nextjs link
const BasicLinkWithRef = (
  { onClick, href, className, children }: BasicLinkProps,
  ref: React.LegacyRef<HTMLAnchorElement> | undefined,
) => (
  <a className={className} onClick={onClick} href={href} ref={ref}>
    {children}
  </a>
)
const BasicLink = React.forwardRef<HTMLAnchorElement, BasicLinkProps>(
  BasicLinkWithRef,
)

BasicLink.displayName = 'BasicLink'

export type CustomLinkProps = BasicLinkProps & {
  as?: 'a'
}

const CustomLink = ({
  as,
  href,
  className,
  children,
  ...rest
}: CustomLinkProps) => {
  const Link = as

  if (Link) {
    return (
      <Link href={href} {...rest}>
        <BasicLink className={className}>{children}</BasicLink>
      </Link>
    )
  }

  return (
    <BasicLink className={className} href={href}>
      {children}
    </BasicLink>
  )
}

export default CustomLink
